
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
const supplier = namespace("supplier");
@Component({
  components: { SwitchStatus }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("finance.please-select-supplier"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class Supplier extends Vue {
  @supplier.Action getSupplierList;
  @supplier.Action updateStatus;

  searchForm = {
    searchKey: "",
    contactName: "",
    contactMobile: ""
  };
  emptyToLine = emptyToLine;
  supplierList: any[] = [];
  tableLoading: boolean = false;
  showStartTips: boolean = false;
  searchList: any[] = [
    {
      label: t("test.keyword"),
      type: "input",
      placeholder: t("v212.enter-supplier-name/business-commodity/business-scope-query"),
      value: "",
      prop: "searchKey"
    },
    {
      label: t("supplier.supplier-contact"),
      type: "input",
      value: "",
      prop: "contactName"
    },
    {
      label: t("base.contacts-mobile"),
      type: "input",
      value: "",
      prop: "contactMobile"
    }
  ];
  handleSearch(data) {
    this.mix_pageNum = 1;

    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow) {
    this.updateStatus({
      status: status,
      codeList: selectedRow ? [selectedRow.supplierCode] : this.mix_selectedRows.map(item => item.supplierCode)
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
  created() {
    this.init();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getSupplierList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      status: "9"
    }).then(data => {
      this.supplierList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  async init() {
    this.loadListData();
  }
  handleEdit(row) {
    this.$router.push(`/setting/supplier-edit/${row.supplierCode}`);
  }
}
